import { createReducer, on, Action } from '@ngrx/store';

import {
    InitGoogleTagManagerSuccess,
} from './google-services.actions';
import { googleServicesInitialState, GoogleServicesState } from './google-services.state';

const googleServicesReducerDefinition = createReducer(
    googleServicesInitialState,

    on(InitGoogleTagManagerSuccess, (state: GoogleServicesState): GoogleServicesState => {
        return {
            ...state,
            enabled: true,
        };
    }),
);

export function googleServicesReducer(state: GoogleServicesState, action: Action): GoogleServicesState {
    return googleServicesReducerDefinition(state, action);
}
